import styled from 'styled-components'

export const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 10000;
  width: 100%;

  [data-sl-alert] {
    width: 100%;
    border-radius: 0;
  }
`
